/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import { Button, Divider, Typography2, useTheme } from '@coursera/cds-core';
import { AddIcon } from '@coursera/cds-icons';

import { Section } from 'bundles/enterprise-admin-user-filters/components/ui';
import { Spacer } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-user-filters';

const ActivityFilterSectionZeroState = ({ onAddActivityFilter }: { onAddActivityFilter: () => void }) => {
  const theme = useTheme();
  return (
    <Section isZeroState>
      <Typography2 component="h3" variant="subtitleMedium">
        {_t('Activity filter')}
      </Typography2>
      <Spacer size={8} />
      <Divider />
      <Spacer size={8} />
      <Typography2 component="p">
        {_t('Filter further by learner activities, such as enrollment, completions, inactivity and progress.')}
      </Typography2>
      <Spacer size={12} />
      <Button
        css={css`
          ${theme.breakpoints.down('xs')} {
            width: 100%;
            max-width: none;
          }
        `}
        variant="secondary"
        size="small"
        icon={<AddIcon size="small" />}
        iconPosition="before"
        onClick={onAddActivityFilter}
        data-testid="add-activity-filter"
      >
        {_t('Add activity filter')}
      </Button>
    </Section>
  );
};

export default ActivityFilterSectionZeroState;
